import React from "react";
import styled from "styled-components";
import { Button, ButtonTheme } from "./Button";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 40px 16px;
  text-align: center;
  font-family: Nunito;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: var(--subtitle);

  p {
    margin: 0;
  }
`;

/** Shown while a download is in flight; announced politely. */
export const Loading = ({ what }: { what: string }) => (
  <Container>
    <p role="status">Loading {what}…</p>
  </Container>
);

/** Shown when a download failed; the retry clears the failure upstream. */
const LoadError = ({ what, onRetry }: { what: string; onRetry: () => void }) => (
  <Container>
    <p role="alert">
      {what} could not be loaded. Check your connection and try again.
    </p>
    <Button
      button
      theme={ButtonTheme.light_outline}
      text="Try again"
      onClick={onRetry}
    />
  </Container>
);

export default LoadError;
